/* src/app/modules/portal/components/lastDataSourceRefresh/lastDataSourceRefreshTubeCoil/lastDataSourceRefreshTubeCoil.component.css */
s.container {
  background-color: white !important;
  height: fit-content;
}
.data-state {
  overflow-wrap: break-word;
  width: 9rem;
}
@media (max-width: 767px) {
  .data-state {
    overflow-wrap: break-word;
    width: 10rem;
  }
}
@media (max-width: 1025px) and (min-width: 768px) {
  .data-state {
    overflow-wrap: break-word;
    width: 7rem;
  }
}
@media (max-width: 2559px) and (min-width: 1025px) {
  .data-state {
    overflow-wrap: break-word;
    width: 7rem;
  }
}
:host {
  background-color: white;
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .display-text {
    padding-top: 10px;
  }
}
@media (min-width: 320px) and (max-width: 1024px) {
  .display-text {
    display: flex;
    padding-top: 10px;
  }
}
@media (min-width: 1441px) {
  .display-text {
    display: flex;
    padding-top: 10px;
  }
}
/*# sourceMappingURL=lastDataSourceRefreshTubeCoil.component.css.map */
